export const createOddsElement = ({ sport, odds, url, label, types }) => {
	if (!Array.isArray(odds)) {
		return null;
	}

	return odds
		.map(({ type, data }) => {
			if (!types.includes(type)) {
				return null;
			}
			switch (type) {
				case "3way-result":
					return create3wayResult(sport, data, url, label);
				case "over-under-line":
					return createOverUnderLine(sport, data, url, label);
			}
			return null;
		})
		.filter((item) => item !== null)
		.join("\n");
};

const create3wayResult = (sport, data, url, label) => {
	let home = data["1"];
	let draw = data["x"];
	let away = data["2"];

	const { variation } = data;

	if (!home || !draw || !away) {
		return null;
	}

	if (!url) {
		url = `/till/${sport}-odds/`;
	}

	return `<span class="sn-live-odds-item"><a href="${url}" target="_blank" class="sn-odds-link">
	<table class="sn-odds sn-odds--1">
	<tbody><tr class="sn-odds-row">
	<th class="sn-odds-title">${label}</th>
	<td class="sn-odds-cell"><span class="sn-odds-item"><span class="sn-odds-item-label">1</span><span class="sn-odds-item-value">${home}</span></span></td>
	<td class="sn-odds-cell"><span class="sn-odds-item"><span class="sn-odds-item-label">X</span><span class="sn-odds-item-value">${draw}</span></span></td>
	<td class="sn-odds-cell"><span class="sn-odds-item"><span class="sn-odds-item-label">2</span><span class="sn-odds-item-value">${away}</span></span></td>
	${variation ? `<td class="sn-odds-variation">(${variation})</td>` : ""}
	</tr>
	</tbody></table>
	</a></span>`;
};

export const createOverUnderLine = (sport, data, url, label) => {
	const {
		over: { total: overTotal, value: over },
		under: { total: underTotal, value: under },
	} = data;

	if (!over || !under) {
		return null;
	}

	if (!url) {
		url = `/till/${sport}-odds/`;
	}

	return `<span class="sn-live-odds-item"><a href="${url}" target="_blank" class="sn-odds-link">
	<table class="sn-odds sn-odds--5">
	<tbody><tr class="sn-odds-row">
	<th class="sn-odds-title">${label}</th>
	<td class="sn-odds-cell"><span class="sn-odds-item"><span class="sn-odds-item-label"><span class="sn-data-text-sm" data-before="Ö"></span><span class="sn-hidden-sm">Över</span> ${over}</span><span class="sn-odds-item-value">${overTotal}</span></span></td>
	<td class="sn-odds-cell"><span class="sn-odds-item"><span class="sn-odds-item-label"><span class="sn-data-text-sm" data-before="U"></span><span class="sn-hidden-sm">Under</span> ${under}</span><span class="sn-odds-item-value">${underTotal}</span></span></td>
	</tr>
	</tbody></table>
	</a></span>`;
};
